export const LIQUIDATION_BID_DISCOUNT_MIN = 0;
export const LIQUIDATION_BID_DISCOUNT_MAX = 30;
export const LIQUIDATION_BID_DISCOUNT_DEFAULT = 2.5;

export const DISCOUNT_BASIS_POINTS_PER_PERCENT = 100;

export const LIQUIDATION_BID_DISCOUNT_DEFAULT_BPS = Math.round(
  LIQUIDATION_BID_DISCOUNT_DEFAULT * DISCOUNT_BASIS_POINTS_PER_PERCENT
);
